import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-right"} maskId="square-filled-radius-0-stroke-1-IconChevronRight"><path fillRule="evenodd" clipRule="evenodd" d="M9.00008 3.29297L17.7072 12.0001L9.00008 20.7072L8.29297 20.0001L16.293 12.0001L8.29297 4.00008L9.00008 3.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronRight;
